<template>
  <!-- 客戶 / 供應商的登入帳號:顯示帳號;沒有帳號時可以建立,有帳號時可以還原初始密碼 -->
  <v-row dense align="center">
    <v-col>
      <v-text-field
        :value="account ? account.username : '-'"
        :label="label"
        :loading="loading"
        readonly
      ></v-text-field>
    </v-col>
    <v-col cols="auto">
      <v-btn
        v-if="!account"
        color="primary"
        :disabled="loading"
        :loading="busy"
        @click="createAccount"
      >{{ $t("account.create-account") }}</v-btn>
      <v-tooltip v-else bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="warning"
            :loading="busy"
            v-bind="attrs"
            v-on="on"
            @click="resetPassword"
          >{{ $t("customer.reset-password") }}</v-btn>
        </template>
        <span>{{ $t("customer.reset-password-tip") }}</span>
      </v-tooltip>
    </v-col>
  </v-row>
</template>
<script>
import { mapState } from "vuex";
export default {
  props: {
    // 例如 "/customer/customer/1/"
    url: { type: String, required: true },
    label: { type: String, required: true },
  },
  data: () => ({
    account: null,
    loading: false,
    busy: false,
  }),
  computed: {
    ...mapState(["token"]),
    authConfig() {
      return { headers: { Authorization: "JWT " + this.token } };
    },
  },
  watch: {
    url: { handler: "loadAccount", immediate: true },
  },
  methods: {
    loadAccount() {
      const url = this.url;
      this.account = null;
      this.loading = true;
      this.axios
        .get(process.env.VUE_APP_SERVER_URL + url + "account/", this.authConfig)
        .then((response) => {
          if (this.url === url) this.account = response.data || null; // 已換成別筆資料就丟掉
        })
        .catch((error) => console.log(error))
        .finally(() => {
          this.loading = false;
        });
    },
    createAccount() {
      this.busy = true;
      this.axios
        .post(process.env.VUE_APP_SERVER_URL + this.url + "create_account/", {}, this.authConfig)
        .then((response) => {
          this.account = response.data;
          alert(this.$t("account.create-account-done", { username: response.data.username }));
        })
        .catch((error) => alert(JSON.stringify(error.response ? error.response.data : error.message)))
        .finally(() => {
          this.busy = false;
        });
    },
    resetPassword() {
      if (!confirm(this.$t("customer.reset-password-confirm", { username: this.account.username }))) return;
      this.busy = true;
      this.axios
        .post(process.env.VUE_APP_SERVER_URL + this.url + "reset_password/", {}, this.authConfig)
        .then(() => alert(this.$t("customer.reset-password-done")))
        .catch((error) => alert(JSON.stringify(error.response ? error.response.data : error.message)))
        .finally(() => {
          this.busy = false;
        });
    },
  },
};
</script>
